import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from '../../CommonComponent';
import { selectors as imgSelector, selectors as headerSelector } from '../../../state/features/header';
import { useSelector } from 'react-redux';
import { RESOURCE } from '../../../const/resource';
import { useTranslation } from "react-i18next";
import "./komatsucredithistory.scss"
import { IProps } from './komatsucredithistoryinterface';
import partsService from "../../../services/partsservice";
import helperfunctions from '../../../utils/helperfunctions';
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import moment from "moment";
import { ExcelExport } from '@progress/kendo-react-excel-export';
import Loader from '../../Loader';
import { XLsvg } from "../../../assets/images/index"

const AmountFormat = (item: any) => {
    return (<td><span className="float-right">{getNumericFormat(item.dataItem.amount ?? 0)}</span></td>)
}

const getNumericFormat = (value: any ) => {
    const formatedvalue = helperfunctions.formatAmount(value ?? 0);
    return (value >= 0 ? `$${formatedvalue}` : `$(${formatedvalue?.replace("-",'')})`);
}

const TransactionDateFormat = (item: any) => {
    return (<td><span>{item.dataItem.transactionDateExport}</span></td>)
}

const DetailComponent = (props: any) => {
    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
    }));
    const [mount, setMount] = useState({ flag: false, data: [] });
    const exportRefDetail = React.createRef<ExcelExport>();
    const gridRefDetail = useRef<any>();
    const imgUrl = imgBaseUrlSelectors;
    const { t } = useTranslation();
    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state),
        })
        );

    const getTransactionDate = (date: any) => {
        let formattedDateTime = "";
        if (date != undefined && date != '' &&
            moment(date).format("MM/DD/YYYY hh:mm:ss") != "01/01/0001 12:00:00") {
            const refreshTime = helperfunctions.DateFormatbasedONRegion(date, headercurrentuser?.userpreference?.culture);
            const refeshTimeZone = moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).zoneAbbr();
            let onlytimeConversion = moment(date ? date + 'Z' : date).format('hh:mm A');
            formattedDateTime = `${refreshTime} ${onlytimeConversion} ${refeshTimeZone}`;
        }
        return formattedDateTime;
    }

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [komatsuCreditDetailData, setPunchoutDetailData] = useState<[]>([]);
    const nestedColumns = [
        {
            field: 'distributor',
            title: t(RESOURCE.MyK_Label_Distributor),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
        },
        {
            field: "userName",
            title: t(RESOURCE.MyK_Label_SC_KCH_Username),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
        },
        {
            field: 'transactionId',
            title: t(RESOURCE.MyK_Label_SC_KCH_TransactionId),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu',
        },
        {
            field: 'transactionDate',
            title: t(RESOURCE.MyK_Label_SC_KCH_TransactionDate),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu',
            format: "{0: MM/dd/yyyy}",
            type: "date",
            filter: "date",
            cell: TransactionDateFormat
        },
        {
            field: 'amount',
            title: t(RESOURCE.MyK_Label_SC_KCH_Amount),
            sortable: true,
            filterable: true,
            filter: "numeric",
            cell: AmountFormat,
            columnMenu: 'ColumnMenu'
        },
        {
            field: "comments",
            title: t(RESOURCE.MyK_Label_Comments),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
        },
        {
            field: "actionType",
            title: t(RESOURCE.MyK_Label_SC_KCH_ActionType),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true
        },
    ]
    const exportColumnsDetails = [
        {
            field: 'distributor',
            title: t(RESOURCE.MyK_Label_Distributor),
        },
        {
            field: "userName",
            title: t(RESOURCE.MyK_Label_SC_KCH_Username),
        },
        {
            field: 'transactionId',
            title: t(RESOURCE.MyK_Label_SC_KCH_TransactionId),
        },
        {
            field: 'transactionDateExport',
            title: t(RESOURCE.MyK_Label_SC_KCH_TransactionDate),
        },
        {
            field: 'amountExport',
            title: t(RESOURCE.MyK_Label_SC_KCH_Amount),
        },
        {
            field: "comments",
            title: t(RESOURCE.MyK_Label_Comments)
        },
        {
            field: "actionType",
            title: t(RESOURCE.MyK_Label_SC_KCH_ActionType),
        },
    ]

    useEffect(() => {
        getKomatsuCreditHistoryDetails();
    }, [])

    const getKomatsuCreditHistoryDetails = () => {
        setIsLoading(true);
        partsService.getKomatsuCreditHistoryDetail(globalData.CustomerId, props.dataItem.creditEntryId)
            .then((response: any) => {
                const result = response?.map((item: any) => ({
                    ...item,
                    transactionDateExport : getTransactionDate(item.transactionDate),
                    amountExport: getNumericFormat(item.amount??0),
                    transactionDate: item.transactionDate ? new Date(moment(item.transactionDate).format("MM/DD/YYYY")) : item.transactionDate,
                }));
                setIsLoading(false);
                setPunchoutDetailData(result ?? []);
            })
            .catch((e: any) => {
                setIsLoading(false);
                helperfunctions.showErrorMessage(e);
            });
    }

    const exportToExcelDetail = () => {
        setMount({ flag: true, data: gridRefDetail?.current?.data ?? komatsuCreditDetailData });
    }

    useEffect(() => {
        if (exportRefDetail.current) {
            exportRefDetail.current.save();
        }
    }, [mount?.data]);

    return (
        <div>
            {isLoading && <Loader />}
            <div className="bookmarked_header clearfix">
                <div className="exportExecl" onClick={exportToExcelDetail} onKeyDown={() => { }}><span><img src={imgUrl + XLsvg} className="mr-2" /></span>{t(RESOURCE.MyK_Label_ExportToExcel)}</div>
            </div>
            <DataTable
            storageKey={"komatsuCreditHistoryDetail"} enableFiltering={true}
                data={komatsuCreditDetailData}
                dataColumn={nestedColumns}
                reorderable={true}
            />
            {mount?.flag && <ExcelExport data={mount?.data ?? []} columns={exportColumnsDetails} ref={exportRefDetail} fileName='CustomerCreditHistory'></ExcelExport>}
        </div>
    )
}


const KomatsuCreditHistory = ({ columns, exportColumns }: IProps) => {
    const { t } = useTranslation();
    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
    }));
    const [mount, setMount] = useState({ flag: false, data: [] });
    const [customerCreditInfo, setCustomerCreditInfo] = useState<any>({ loading: false, data: {} });
    const imgUrl = imgBaseUrlSelectors;
    const [komatsuCreditData, setkomatsuCreditData] = React.useState<[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state),
        })
    );

    const exportRef = React.createRef<ExcelExport>();
    const gridRef = useRef<any>();
    useEffect(() => {
        if (globalData.CustomerId != "" && globalData.CustomerId != null) {
            getKomatsuCreditHistory();
            getCustomerCreditInfo();
        }
    }, [globalData.CustomerId])

    const redirectToShoppingCart = () => {
        window.location.href = '/shoppingcart';
    }

    const getCustomerCreditInfo = async () => {
        try {
            const customerId = globalData?.CustomerId ? parseInt(globalData?.CustomerId) : 0;
            setCustomerCreditInfo({ loading: true, data: {} });
            const req = {
                customerId,
                cartId: 0,
                userAadId: headercurrentuser?.azureADId,
            }
            const response = await partsService.getCustomerCreditInfo(req);
            if (response?.isSuccess) {
                setCustomerCreditInfo({ loading: false, data: response?.data ?? {} });
                if (response?.data?.totalCredit <= 0) {
                    redirectToShoppingCart();
                }
            } else {
                
                setCustomerCreditInfo({ loading: false, data: {} });
                if (response?.msg?.trim() != 'Not Found') {
                    helperfunctions.showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_Promo_GetCustomerCreditInfo_Error_Msg)} - ${response?.msg}`);
                }
                redirectToShoppingCart();
            }
        } catch (error) {
            setCustomerCreditInfo({
                loading: false, data: {}
            });
            redirectToShoppingCart();

        }
    };

    const getKomatsuCreditHistory = () => {
        setIsLoading(true);
        partsService.getKomatsuCreditHistory(globalData.CustomerId, headercurrentuser?.azureADId)
            .then((response: any) => {
                const result = response?.map((item: any) => ({
                    ...item,
                    totalCreditExport: getNumericFormat(item.totalCredit??0),
                    remainingCreditExport: getNumericFormat(item.remainingCredit??0),
                    orderDate: item.orderDate ? new Date(moment(item.orderDate).format("MM/DD/YYYY")) : item.orderDate,
                }));
                setkomatsuCreditData(result ?? []);
                setIsLoading(false);
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessage(e);
                setIsLoading(false);
            });
    }

    const exportToExcel = () => {
        setMount({ flag: true, data: gridRef?.current?.data ?? komatsuCreditData });
    };

    useEffect(() => {
        if (exportRef.current) {
            exportRef.current.save();
        }
    }, [mount?.data]);

    const { customer, customerAccountNumber, totalCredit, remainingCredit } = customerCreditInfo?.data || {};

    return (<div className='punchout-history-container'>
        {(isLoading || customerCreditInfo?.loading) && <Loader />}
        <div className='punchouhistory-header-block'>
            <div className=''>
                    <div>
                        <div className='creditInfo'>
                            <div className='creditInfoSub'><label className='creditInfoLbl'>{t(RESOURCE.MyK_Label_Customer_Name)}: </label> <span>{customer}</span></div>
                            <div className='creditInfoSub'><label className='creditInfoLbl'>{t(RESOURCE.MyK_Label_SC_KCH_Account)}#: </label> <span>{customerAccountNumber}</span></div>
                            <div className='creditInfoSub'><label className='creditInfoLbl'>{t(RESOURCE.MyK_Label_SC_KCH_TotalCredit)}: </label> <span>${helperfunctions.formatAmount(totalCredit || 0)}</span></div>
                            <div className='creditInfoSub'><label className='creditInfoLbl'>{t(RESOURCE.MyK_Label_SC_KCH_RemainingBalance)}: </label> <span className='greenLbl'>${helperfunctions.formatAmount(remainingCredit || 0)}</span></div>
                        </div>   
                 </div>

                    <div className="nestedDatatable mt-3">
                        <div className="bookmarked_header clearfix">
                            <div className="exportExecl" onClick={exportToExcel} onKeyDown={() => { }}><span><img src={imgUrl + XLsvg} className="mr-2" /></span>{t(RESOURCE.MyK_Label_ExportToExcel)}</div>
                        </div>
                        <div className="row">
                            <div className="col-12 SavePartsListTableTwo">
                                <DataTable
                                storageKey={"komatsuCreditHistory"} enableFiltering={true}
                                    exportRef={gridRef}
                                    data={komatsuCreditData}
                                    dataColumn={columns}
                                    reorderable={true}
                                    DetailComponent={DetailComponent}
                                    DetailRow={true}
                                    isExpandWithItemChange={true}
                                    dataItemKey='creditEntryId'
                                />
                            </div>
                        {mount?.flag && <ExcelExport data={mount?.data ?? []} columns={exportColumns} ref={exportRef} fileName="CustomerCreditDetails"></ExcelExport>}
                        </div>
                    </div>
                </div>
            </div>  </div>
    )
}

export default KomatsuCreditHistory;